import React,{useContext} from 'react';
import Http from '../api/Http'
import { jwtDecode } from "jwt-decode";
import { ActiveContext } from '../../Context/Context';
import { data } from 'autoprefixer';


/**
 * Logs in with shorts generated credentials.
 *
 * @param {object} data 
 * @returns {Promise} 
 */


export const LoginUpForm = async (data) => {
  try {
    localStorage.clear();

    const response = await Http.post('/Registration/logIn', (data));
    // console.log(response.data.data.token)
    localStorage.setItem('Token', response.data.data.token);
    const decoded = jwtDecode(response.data.data.token);
    localStorage.setItem('userid',decoded.userId)
    localStorage.setItem('email', decoded.email)
    localStorage.setItem('firstName',decoded.firstName);
    localStorage.setItem('lastName',decoded.lastName);
    localStorage.setItem('MarkDone',decoded.markAsDone);
    localStorage.setItem('checkBox', decoded.acceptAlert);
    
    return response.data;
    
  } catch (err) {
    console.error("Error in LoginUpForm:", err);
    throw err;
  }
};

export const SendEmail = async(data) =>{
  console.log(data,'email')
  try{
    const response = await Http.post('/Registration/forgotPassword', data);
    return response
  }catch(err){
    console.log("Error in SendEmail:", err);
    throw err
  }
}
export const UpdatePassword = async(data) =>{
  try{
    const response = await Http.post('/Registration/passwordUpdate',data)
    return response
  }catch(err){
    console.error(err)
  }
}
export const GoogleForm = async (data) => {
  try {
    const response = await Http.post('/Registration/loginWithGoogle', (data));
    console.log(response.data.data,'google response')
    localStorage.setItem('Token', response.data.data.token);
    const decode = jwtDecode(response.data.data.token)
    localStorage.setItem('userid',decode.userId)
    localStorage.setItem('email', decode.email)
    localStorage.setItem('firstName',decode.firstName);
    localStorage.setItem('lastName',decode.lastName);
    localStorage.setItem('MarkDone',decode.markAsDone);
    localStorage.setItem('checkBox', decode.acceptAlert);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const ActivePlan = async ()=>{
  //const { setPlan, setExpiryDate } = useContext(ActiveContext);
  try {
    const res = await Http.get('/Registration/plandetails')
    //localStorage.setItem('PlanTypeName', res.data.data.PlanTypeName)
    return res
    // setPlan(res.data.data.PlanTypeName)
    // setExpiryDate(res.data.data.plainEpiryFormatDate)
  } catch (error) {
    console.error("Plan Fetch error",error)
  }
  
}

export const Checkedbox = async (data)=>{
  try {
    const res = await Http.post('/Registration/acceptAlert',(data))
    return res;

  }catch(error){
    console.error("Error in Checkbox",error)
  }
}

export const SubcriptionCancel = async(data)=>{
  try{
    const res = await Http.post('/Registration/cancelSubscription',data)
    return res;

  }catch(error){
console.error(error,'Subscription not cancled')
  }
}

export const SignUpForm = async (data) => {
  try {
    localStorage.clear();
    const response = await Http.post('/Registration/signUp', (data));
    localStorage.setItem('Token', response.data.data.token);
    const decoded = jwtDecode(response.data.data.token);
    localStorage.setItem('userid',decoded.userId)
    localStorage.setItem('firstName',decoded.firstName);
    localStorage.setItem('lastName',decoded.lastName);
    localStorage.setItem('checkBox', decoded.acceptAlert);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const Sendmail = async(data) =>{
  try{
    const res = await Http.post('/cards/senddisputeletter',data);
    return res;
  }catch(err){
    console.error("Error in SendMail",err)
  }
}

export const MarkDone = async ()=>{
  try {
    const res = await Http.get('/Registration/marktrue');
    return res

  }catch(error){
    console.error("Mark Done error",error)
  }
}



export const editCard = async (data) => {
  try {
    const response = await Http.put('/cards/edit', (data));
    return response
  }
  catch (err) {
    throw err;
  }
};

export const handleOtp = async (data)=>{
  try {
    let data1={
      email:data
    }
    const response = await Http.post('/Registration/sendotp',
      
      (data1));
    return response
  }
  catch (err) {
    throw err;
  }
}

export const chatBot = async(data)=>{
  try{
    //console.log(data,'rorororo')
    const response = await Http.post('/cards/chatbot',(data));
    //console.log(response.data,'pileseee')
    return response.data
  }catch(error){
    console.log(error,'Error in sending message')
  }
}

export const ChatList = async()=>{
  try{
    const response = await Http.get('/cards/chatbotlisting');
    //console.log(response.data,'chatlist')
    return response.data

  }catch(err){
    console.log(err)
  }
}


export const deleteCard = async (id) => {
  try {

    const response = await Http.put('/cards/delete', (id));
    return response.data
  }
  catch (err) {
    throw err;
  }
};


export const getCardDetails = async (id) => {
  try {
    const response = await Http.get('/cards/mycards', (id));
    return response
  }
  catch (err) {
    throw err;
  }
};

export const getAiRecommendations = async (cards) => {
  try {
    const response = await Http.post('/cards/airecommendation', {"cards": cards});
    return response.data.data
  }
  catch (err) {
    throw err;
  }
};


export const addCards = async (data) => {
  try {
    const response = await Http.post('/cards/addcard', data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const disputeRes = async (data)=>{
  try {
    const response = await Http.get('/cards/aicollection',data);
    return response.data;
  }catch(err){
    throw err;
  }
}
export const DisputeLetter = async (data)=>{
  try {
    const response = await Http.post('/cards/createdisputeletter',data);
    return response.data;

  }catch(err){
    throw err;
  }
}